import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dashboardadmin',
  templateUrl: './dashboardadmin.component.html',
  styleUrls: ['./dashboardadmin.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('fadeIn', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class DashboardadminComponent implements OnInit {

  public widthSidebar: number;
  public innerWidthWindow: number;
  public showSideBar: boolean = true;

  ngOnInit() {
    this.innerWidthWindow = window.innerWidth;
    // this.validaResolucion(this.innerWidthWindow);
    this.widthSidebar = 100;

  }

  ngAfterViewInit(): void {

  }

  public validaResolucion(innerWidth: number) {
    if (innerWidth >= 1024) {
      this.widthSidebar = 30;
    } else if (innerWidth >= 992) {
      this.widthSidebar = 35;
    } else if (innerWidth >= 768) {
      this.widthSidebar = 50;
    } else {
      this.widthSidebar = 80;
    }
  }

  public incrementWidthDashboard(width: number) {
    if (width) {
      this.widthSidebar = width;
    } else {
      this.validaResolucion(this.innerWidthWindow);
    }
  }
}
